export default function pages(state = [], action) {
  switch (action.type) {
    case 'RECEIVE_PAGE':
      return [...state, action.payload]
    default:
      return state
  }
}

export function getPageByPermalink(state, permalink) {
  return state.find(page => page.permalink === permalink)
}
